import { $i18n } from "@/utils";
export const token = state => state.token;
export const routesList = state => state.routesList;
export const rememberPass = state => state.rememberPass;
export const userNickname = state => state.userNickname;
export const curCurrency = state => state.user.curCurrency;
export const warningIntervals = () => ({1:$i18n('user.warningIntervals.1'),3: $i18n('user.warningIntervals.3'),7:$i18n('user.warningIntervals.7')});
export const chargeType = () => ({0: $i18n('user.chargeType.0'), 1: $i18n('user.chargeType.1'), 2: $i18n('user.chargeType.2')});
